import {
	Loader,
} from '@tfo/common'

import { observer } from 'mobx-react'
import * as React from 'react'
import { useEffect } from 'react'

import { useParams } from 'react-router-dom'
import { useReportStoreBackoffice } from '../hooks/useReportStoreBackoffice'
import { IntlProviderWrapper } from '../IntlProviderWrapper'
import ReadReportCore from './ReadReportCore'


const ReadReportBackoffice = observer(({ closeReport }: { closeReport?: () => void }) => {
	const [store, setCookieData] = useReportStoreBackoffice()

	useEffect(() => {
		window.addEventListener("message", handleMessage);
		return () => window.removeEventListener("message", handleMessage);
	},[])

	const handleMessage = (ev: MessageEvent) => {
		if (ev.type == 'message' && ev.data.type == 'cookie') {
			const cookieValue = ev.data.cookie;
			if (cookieValue) {
				setCookieData(cookieValue);
			}
		}
	};

	return store.reportStore?.order ? (
		<IntlProviderWrapper languageSettings={{language: store.reportStore.order.language}}>
			<ReadReportCore closeReport={closeReport} store={store} />
		</IntlProviderWrapper>
	) : (
		<Loader />
	)
})

export default ReadReportBackoffice
